module.exports = __webpack_public_path__ + "static/media/icon-basic-info.3ff09825.svg";